// 指定段落高亮文字
export function brightenKeyword(contentText, keyword) {
    let wordsArray = keyword;
    let res = contentText;//res的初始值是不带任何红色格式的
    let hightlightText = res.replace(new RegExp(`(${keyword.join('|')})`, 'img'), `<span class="_light_text" style="color: #1D88D0;">$1</span>`);
    return hightlightText;
}

// 指定段落高亮文字
export function keyLight(dom, key, bgColor){
    var oDiv = dom,
        oChilds  = oDiv.html(),
        bgColor = bgColor || "orange",
        oKey = [...key].join('|'),store = {length: 0};

    let _out_str = ''

    console.info(oChilds)

    // 复制一个节点去进行遍历操作
    let wrap = document.createElement('div');

    wrap.innerHTML = oChilds;

    _out_str = DFSTraverseAndHightlight(wrap);

    function DFSTraverseAndHightlight (node) {
        const rootNodes = node.childNodes;
        const childNodes = Array.from(rootNodes);

        for(let i = 0, len = childNodes.length; i < len; i++) {
            const node = childNodes[i];

            // 文本节点，要进行高亮
            if (node.nodeType === 3) {
                let span = document.createElement('span');
                let a = span.innerHTML = node.nodeValue.replace(new RegExp(`(${oKey})`, 'g'), `<span class="_light_text" style="color: ${bgColor};">$1</span>`);
                node.parentNode.insertBefore(span, node);
                node.parentNode.removeChild(node);
            }

            //文本节点不会有childNodes属性，如果有子节点，继续遍历
            if (node.childNodes.length) {
                DFSTraverseAndHightlight(node);
            }
        }

        return node.innerHTML;
    }

    oDiv.html(_out_str)
  }

//处理阅读数 需求 <300不显示
export function readFn(read_number){
    if(read_number <= 300){
        return '';
    }
    else if(read_number > 10000){
        return (read_number / 10000).toFixed(1) + "万次阅读";
    }
    else{
        return read_number + "次阅读";
    }

}
//处理时间
export function rec_time(time, type){
    // 
    if(typeof time == 'string') {
        time = time.replace(/-/g, '/')
    }
    let today = new Date(),date1 = new Date(time);
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1)

    //
    // let lastDay = today.getTime() - 24 * 60 * 60 * 1000;

    // if(date1.getTime() > lastDay) {
    //     return `${formate10(date1.getMonth()+1)}-${formate10(date1.getDate())} ${formate10(date1.getHours())}:${formate10(date1.getMinutes())}`
    // } else {
    //     return `${formate10(date1.getMonth()+1)}-${formate10(date1.getDate())}`
    // }

    if(date1 == 'Invalid Date'){
        return time;
    }

    let _sf = `${formate10(date1.getHours())}:${formate10(date1.getMinutes())}`;// comment
    if(today.toDateString() == date1.toDateString()){
        //同天的
        return _sf;
    }
    if(type == 'comment') {
        _sf = '';
    }
    if(today.getFullYear() == date1.getFullYear()){
        //同年的
        return `${formate10(date1.getMonth()+1)}-${formate10(date1.getDate())} ${_sf}`
    }
    else{
        return `${date1.getFullYear()}-${formate10(date1.getMonth()+1)}-${formate10(date1.getDate())} ${_sf}`
    }
    return

    if(date1 == 'Invalid Date'){
        return time;
    }
    if(today.toDateString() == date1.toDateString()){
        //同天的
        return `${formate10(date1.getHours())}:${formate10(date1.getMinutes())}`;
    }
    else if(date1.toDateString() == yesterday.toDateString()){
        //昨天的
        return `昨天 ${formate10(date1.getHours())}:${formate10(date1.getMinutes())}`;
    }
    else if(today.getFullYear() == date1.getFullYear()){
        //同年的
        return `${formate10(date1.getMonth()+1)}-${formate10(date1.getDate())} ${formate10(date1.getHours())}:${formate10(date1.getMinutes())}`
    }
    else{
        return `${date1.getFullYear()}-${formate10(date1.getMonth()+1)}-${formate10(date1.getDate())} ${formate10(date1.getHours())}:${formate10(date1.getMinutes())}`
    }
}
//个位数加0
function formate10(num){
    if(num < 10){
        num = '0'+num;
    }
    return num;
}

//处理粉丝名称
export function funNameFn(id){
    //1124  -》源头主升浪 源军
    //1001-》主升军团 财团
    if(id == 1124){
        return '源军';
    }
    else if(id == 1001){
        return '财团';
    }
    else{
        return '铁粉';
    }
}